module.exports = __webpack_public_path__ + "img/mr.ed06d0be.svg";